<div class="dash-shell">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <a class="page-head__crumb" routerLink="/ops/dashboard">Ops</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      <span class="page-head__crumb page-head__crumb--current" aria-current="page"
        >Breaching SLA</span
      >
    </nav>
    <div class="page-head__bar">
      <div class="page-head__titles">
        <h1 class="page-head__title">Breaching SLA</h1>
        @if (!isLoading() && !loadError()) {
          <p class="page-head__subtitle">
            {{ count() }} item{{ count() === 1 ? '' : 's' }} past the review deadline — most
            overdue first
          </p>
        }
      </div>
    </div>
  </header>

  @if (isLoading()) {
    <ul class="breach-list breach-list--skeleton">
      @for (r of skeletonRows; track r) {
        <li><span class="sg-skeleton sg-skeleton--text sg-skeleton--w60"></span></li>
      }
    </ul>
  } @else if (loadError()) {
    <div class="sg-empty sg-empty--error sg-empty--bordered">
      <app-icon name="x-circle" [size]="40" />
      <p class="sg-empty__title">Couldn't load the breach list</p>
      <p class="sg-empty__desc">Something went wrong on our side.</p>
      <button class="breach-retry" type="button" (click)="reload()">
        <app-icon name="refresh" [size]="18" /> Try again
      </button>
    </div>
  } @else if (count() === 0) {
    <div class="sg-empty sg-empty--bordered breach-empty--ok">
      <app-icon name="check" [size]="40" />
      <p class="sg-empty__title">Nothing is breaching SLA</p>
      <p class="sg-empty__desc">Every item in review is still within its deadline. Nice work.</p>
      <a class="breach-retry" routerLink="/ops/dashboard">
        <app-icon name="arrow-left" [size]="18" /> Back to dashboard
      </a>
    </div>
  } @else {
    <div class="dash-panel">
      <ul class="breach-list">
        @for (item of items(); track item.short_id) {
          <li>
            <a class="ops-work-item ops-work-item--overdue" [routerLink]="item.url">
              <span class="ops-work-item__product" [attr.data-product]="item.product">{{
                item.product
              }}</span>
              <span class="ops-work-item__ref">{{ item.short_id }}</span>
              <span class="ops-work-item__main">
                <span class="ops-work-item__entity">{{ item.entity_name }}</span>
                <span class="ops-work-item__meta">
                  {{ queueLabel(item.queue) }} · {{ item.amount | zar }}
                </span>
              </span>
              @if (item.ai_recommendation) {
                <span class="ops-work-item__ai" [class]="aiRecClass(item.ai_recommendation)">
                  AI: {{ aiRecLabel(item.ai_recommendation) }}
                </span>
              }
              <span class="ops-work-item__sla">{{ overdueLabel(item.hours_overdue) }}</span>
              <app-icon class="ops-work-item__chevron" name="arrow-right" [size]="16" />
            </a>
          </li>
        }
      </ul>
    </div>
  }
</div>
